import React, { createContext, useContext, useState } from 'react';

const FormContext = createContext();

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useFormContext must be used within FormProvider');
  }
  return context;
};

export const FormProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <FormContext.Provider value={{ currentStep, setCurrentStep }}>
      {children}
    </FormContext.Provider>
  );
};
